module.exports = __webpack_public_path__ + "img/title1.215220c2.png";